'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Components


// Utils


// Constants


// Styles


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _elementUtil = require('../elementUtil');

var _lodash = require('lodash');

var _EditableTitle = require('../../components/editableTitle/EditableTitle');

var _EditableTitle2 = _interopRequireDefault(_EditableTitle);

var _BoardIcon = require('./boardIcon/BoardIcon');

var _BoardIcon2 = _interopRequireDefault(_BoardIcon);

var _ContainerElementChildCount = require('../containerElement/ContainerElementChildCount');

var _ContainerElementChildCount2 = _interopRequireDefault(_ContainerElementChildCount);

var _dontUpdateForKeys = require('../../utils/milanoteRecompose/dontUpdateForKeys');

var _dontUpdateForKeys2 = _interopRequireDefault(_dontUpdateForKeys);

var _containerElementSelector = require('../containerElement/containerElementSelector');

var _gridUtils = require('../../utils/grid/gridUtils');

var _permissionUtil = require('../../../common/permissions/permissionUtil');

var _boardSelector = require('./boardSelector');

var _boardConstants = require('../../../common/boards/boardConstants');

var _userConstants = require('../../../common/users/userConstants');

require('./Board.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isSharedSelector = function isSharedSelector() {
    return (0, _reselect.createSelector)(function (state, props) {
        return props.element;
    }, function (element) {
        var acl = element.get('acl');
        if (!acl || !acl.size) return false;

        // don't show shared icon on public demo board alias
        var publicAccess = acl.get(_userConstants.PUBLIC_USER_ID);
        return !(publicAccess && (0, _permissionUtil.isDemoBoard)(publicAccess));
    });
};

var makeBoardSelector = function makeBoardSelector() {
    return (0, _reselect.createSelector)((0, _containerElementSelector.makeContainerElementChildrenTypesSelector)(), isSharedSelector(), _boardSelector.getIsBoardFetched, function (childrenTypes, isShared, isBoardFetched) {
        return {
            childrenTypes: childrenTypes,
            isShared: isShared,
            isBoardFetched: isBoardFetched
        };
    });
};

var BoardIconElement = function BoardIconElement(props) {
    var element = props.element,
        children = props.children,
        isAlias = props.isAlias,
        isLinkAlias = props.isLinkAlias,
        isLocked = props.isLocked,
        isShared = props.isShared,
        documentMode = props.documentMode,
        registerConnectionOrigin = props.registerConnectionOrigin;


    var color = element.getIn(['content', 'color']);
    var icon = element.getIn(['content', 'icon']);
    var iconSize = documentMode ? 5 : 8;

    return _react2.default.createElement(_BoardIcon2.default, _extends({}, props, {
        registerConnectionOrigin: registerConnectionOrigin,
        size: iconSize,
        element: element,
        color: color,
        icon: icon,
        children: children,
        isShared: isShared,
        isAlias: isAlias,
        isLinkAlias: isLinkAlias,
        isLocked: isLocked }));
};

BoardIconElement.propTypes = {
    element: _propTypes2.default.object.isRequired,
    children: _propTypes2.default.element,
    gridSize: _propTypes2.default.number.isRequired,
    isAlias: _propTypes2.default.bool,
    isLinkAlias: _propTypes2.default.bool,
    isLocked: _propTypes2.default.bool,
    isShared: _propTypes2.default.bool,
    documentMode: _propTypes2.default.bool,
    registerConnectionOrigin: _propTypes2.default.func
};

BoardIconElement = (0, _dontUpdateForKeys2.default)(['isHovered', 'canDrop'])(BoardIconElement);

var Board = (_dec = (0, _reactRedux.connect)(makeBoardSelector), _dec(_class = function (_React$Component) {
    _inherits(Board, _React$Component);

    function Board(props) {
        _classCallCheck(this, Board);

        var _this = _possibleConstructorReturn(this, (Board.__proto__ || Object.getPrototypeOf(Board)).call(this, props));

        _this.handleTouchStart = _this.handleTouchStart.bind(_this);
        return _this;
    }

    _createClass(Board, [{
        key: 'handleTouchStart',
        value: function handleTouchStart(event) {
            var _props = this.props,
                navigateToBoard = _props.navigateToBoard,
                isEditing = _props.isEditing;


            var timeNow = new Date().getTime();
            if (this.lastTouch && this.lastTouch > timeNow - 500) {
                if (isEditing) return;

                return navigateToBoard();
            }

            this.lastTouch = timeNow;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                gridSize = _props2.gridSize,
                inList = _props2.inList,
                onDoubleClick = _props2.onDoubleClick,
                onClick = _props2.onClick,
                connectDropTarget = _props2.connectDropTarget,
                connectLineEdgeDropTarget = _props2.connectLineEdgeDropTarget,
                element = _props2.element,
                onTitleEditDone = _props2.onTitleEditDone,
                isBoardFetched = _props2.isBoardFetched,
                elementEvents = _props2.elementEvents,
                aliasId = _props2.aliasId;


            var classes = (0, _elementUtil.elementClassNames)('Board', this.props);

            var titleContainerStyle = {
                width: (0, _gridUtils.gridPointsToPixels)(20, gridSize)
            };

            var boardContent = _react2.default.createElement(
                'div',
                { className: 'board-content' },
                _react2.default.createElement(BoardIconElement, this.props),
                _react2.default.createElement(
                    'div',
                    { className: 'title-container', style: titleContainerStyle },
                    _react2.default.createElement(_EditableTitle2.default, _extends({}, this.props, {
                        elementId: element.get('id'),
                        initialValue: 'New Board',
                        selectFirst: true,
                        selectAllOnEdit: true,
                        onUpdateCallbackFn: onTitleEditDone,
                        editDelay: 100,
                        editorKey: _boardConstants.BOARD_TYPE })),
                    _react2.default.createElement(_ContainerElementChildCount2.default, _extends({}, this.props, { show: isBoardFetched }))
                )
            );

            var lineEdgeConnector = connectLineEdgeDropTarget && !inList ? connectLineEdgeDropTarget : _lodash.identity;

            var domElementId = aliasId || element.get('id');

            return _react2.default.createElement(
                'div',
                _extends({ id: (0, _elementUtil.getDomElementId)(domElementId), className: classes,
                    style: (0, _gridUtils.getElementStyle)(_boardConstants.DEFAULT_BOARD_WIDTH, gridSize, inList)
                }, elementEvents, {
                    onClick: onClick,
                    onDoubleClick: onDoubleClick,
                    onTouchStart: this.handleTouchStart }),
                connectDropTarget ? connectDropTarget(lineEdgeConnector(boardContent)) : boardContent
            );
        }
    }]);

    return Board;
}(_react2.default.Component)) || _class);
exports.default = Board;


Board.propTypes = {
    element: _propTypes2.default.object.isRequired,
    gridSize: _propTypes2.default.number,
    inList: _propTypes2.default.string,
    isSelected: _propTypes2.default.bool,
    isEditing: _propTypes2.default.bool,
    isDragging: _propTypes2.default.bool,
    onHeadingClick: _propTypes2.default.func,
    updateTitle: _propTypes2.default.func,
    navigateToBoard: _propTypes2.default.func,
    onDoubleClick: _propTypes2.default.func,
    onClick: _propTypes2.default.func,
    connectDropTarget: _propTypes2.default.func,
    connectLineEdgeDropTarget: _propTypes2.default.func,
    onTitleEditDone: _propTypes2.default.func,
    className: _propTypes2.default.string,
    documentMode: _propTypes2.default.bool,
    isBoardFetched: _propTypes2.default.bool,
    elementEvents: _propTypes2.default.object,
    aliasId: _propTypes2.default.string
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/board/Board.js
// module id = 450
// module chunks = 0